export const GET_RECEPTION_DATA_LIST_REQUEST = 'GET_RECEPTION_DATA_LIST_REQUEST'
export const GET_RECEPTION_DATA_LIST_SUCCESS = 'GET_RECEPTION_DATA_LIST_SUCCESS'
export const GET_RECEPTION_DATA_LIST_FAILED = 'GET_RECEPTION_DATA_LIST_FAILED'
